import React from "react";

function Texts() {
  return (
    <div className="mainWrapper">
      <div className="secondaryWrapper">
        <h1 className="neonText">texts</h1>
        <div className="cv">
          <div className="texts">
            <h2>doctoral dissertation</h2>
            <ul>
              <li>
                Vassallo, J. S. (2025). Outward Threads – Intuitive Computers /
                Rational Composers. <br></br>Research Catalogue:{" "}
                <a
                  href="https://www.researchcatalogue.net/view/3422970/3422971"
                  className="link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.researchcatalogue.net/view/3422970/3422971
                </a>
                <br></br>
                Dedicated website:{" "}
                <a
                  href="https://www.outwardthreads.net"
                  className="link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.outwardthreads.net
                </a>
              </li>
            </ul>
            <h2>journal articles</h2>
            <ul>
              <li>
                Vassallo, J. S., Sandred, Ö, Vincenot, J. (2025).
                NeuralConstraints: Integrating a Neural Generative Model with
                Constraint-Based Composition. Embodied Perspectives on Sound and
                Music AI. Frontiers in Computer Sciences, 7.{" "}
                <a
                  className="link"
                  href="https://www.frontiersin.org/journals/computer-science/articles/10.3389/fcomp.2025.1543074/abstract"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.frontiersin.org/journals/computer-science/articles/10.3389/fcomp.2025.1543074/abstract
                </a>
              </li>
              <li>
                Vassallo, J. S. (2024). Exploring Musical Procedural Rhetoric:
                Computational Influence on Compositional Frameworks and Methods
                in the piece "Elevator Pitch". International Journal of Music
                Science, Technology and Art. 6, 1-16.{" "}
                <a
                  className="link"
                  href="https://doi.org/10.48293/IJMSTA-114"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://doi.org/10.48293/IJMSTA-114
                </a>
              </li>
              <li>
                Vassallo, J. S. (2023). Symbolic Musical Resynthesis As An
                Ekphrastic Compositional Practice Using Computational Methods.
                Culture Crossroads, 22, 129–147.{" "}
                <a
                  className="link"
                  href="https://doi.org/10.55877/cc.vol22.443"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://doi.org/10.55877/cc.vol22.443
                </a>
              </li>
            </ul>
            <h2>conference proceedings</h2>
            <ul>
              <li>
                Vincenot, J., Vassallo, J. S., Sandred, Ö. (2025). MOZ'lib and
                PWforMax: Rewiring CAC heritage. Proceedings of the 10th
                International Conference on Music Representation and Notation –
                TENOR.{" "}
                <a
                  className="link"
                  href="https://www.tenor-conference.org/proceedings/2025/11_TENOR2025_Julien_Vincenot.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.tenor-conference.org/proceedings/2025/11_TENOR2025_Julien_Vincenot.pdf
                </a>
              </li>
              <li>
                Vassallo, J. S. (2022). Machinic automation in the process of
                text and music composition: The versificator. Proceedings of the
                7th Colloquium on Artistic Research in Performing Arts (CARPA7).{" "}
                <a
                  className="link"
                  href="https://nivel.teak.fi/carpa7/machinic-automation-in-the-process-of-text-and-music-composition/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://nivel.teak.fi/carpa7/machinic-automation-in-the-process-of-text-and-music-composition/
                </a>
              </li>
            </ul>
            <h2>master’s thesis</h2>
            <ul>
              <li>
                Vassallo, J. S. (2019). Music expert-novice differences in
                speech perception. University of Victoria Repository Dspace.{" "}
                <a
                  className="link"
                  href="http://hdl.handle.net/1828/11061"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  http://hdl.handle.net/1828/11061
                </a>
              </li>
            </ul>
            <h2>bachelor's final works</h2>
            <ul>
              <li>
                Vassallo, J. S. (2013). Fase 4.{" "}
                <a
                  className="link"
                  href="https://artes.biblio.unc.edu.ar/cgi-bin/koha/opac-detail.pl?biblionumber=23573&query_desc=kw%2Cwrdl%3A%20vassallo%20juan"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://artes.biblio.unc.edu.ar/cgi-bin/koha/opac-detail.pl?biblionumber=23573
                </a>
              </li>
              <li>
                Vassallo, J. S. (2008). Sinfonia de Guerra: La relación entre el
                arte y la política en la música de Dmitri Shostakovich.{" "}
                <a
                  className="link"
                  href="https://artes.biblio.unc.edu.ar/cgi-bin/koha/opac-detail.pl?biblionumber=18024&query_desc=kw%2Cwrdl%3A%20vassallo%20juan"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://artes.biblio.unc.edu.ar/cgi-bin/koha/opac-detail.pl?biblionumber=18024
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Texts;
